
export class GenericException {
code: string;
errorCode: any;
message: string;
parameters: Object[];
}

